import React from 'react';
import {IntlProvider, FormattedMessage, useIntl} from 'react-intl';

import {
  Table
} from 'react-lib/frameworks/Table'
import {
  Label,
  Button,
  Input,
  Dropdown
} from 'semantic-ui-react'
import {
  TimeFreeTextBox24
} from 'react-lib/apps/common'

const CardCountUX = (props: any) => {
    return(
      <div
        id="CardCounts"
        style={{margin: "10px", backgroundColor: "rgba(198, 235, 243, 0.2)", height:"90%"}}>
        <div
          id="CardCountUX-div-1"
          style={{display: "flex", alignItems: "center", padding: "15px 10px 0px"}}>
          
          <label
            className="header"
            id="CardCountUX-label-6"
            style={{fontWeight: "bold", fontSize: "18px", marginLeft: "4px"}}>
            {props.languageUX === "en" ? "Counts" : "นับ"}
          </label>
          <div
            id="CardCountUX-div-68"
            style={{ margin: "0px 20px", display: "flex" }}>
            
            <div
              id="CardCountUX-div-72"
              style={{ marginRight: "10px" }}>
              {props.buttonPrint}
            </div>
            <div
              id="CardCountUX-div-73"
              style={{ marginRight: "10px" }}>
              {props.buttonUploadDocument}
            </div>
            <div
              id="CardCountUX-div-74"
              style={{ marginRight: "10px" }}>
              {props.buttonViewDocument}
            </div>
          </div>
        </div>
        <div
          id="CardCountUX-div-3">
          
          <hr
            id="CardCountUX-hr-4">
          </hr>
        </div>
        <div
          id="CardCountUX-div-7"
          style={{height:"90%",margin: "14px 14px",backgroundColor: "#FFFFFF"}}>
          
          <div
            id="CardCountUX-div-59">
            {props.CountTables}
          </div>
          <div
            id="CardCountUX-div-23"
            style={{height:"auto",margin: "20px 25px"}}>
            
            <Table
              className="--rt-tbody-overflow-y-hidden"
              data={props.items}
              getTrProps={props.shiftTableRowProps}
              headers=",Time,Swab,Sharp,Instrument,Scrub Nurses,Circulating Nurses"
              id="CardCountUX-Table-24"
              keys="shift_name,start_time,swabStatus,sharpStatus,instrumentStatus,scrub_nurses_name,circulating_nurses_name"
              showPagination={false}
              style={{height: "20vh"}}
              widths="auto,110,150,150,150,300,300">
            </Table>
            <div
              id="CardCountUX-div-25"
              style={{border:"1px solid #ccc", borderRadius: "4px", padding: "0px 8px 4px 10px", margin:"10px 0px"}}>
              
              <Label
                color={props.ORCountsSequence?.selectedShift?.id ? "yellow":"blue"}
                id="CardCountUX-Label-26"
                ribbon={true}
                style={{margin:"10px 3px"}}>
                {props.ORCountsSequence?.selectedShift?.id ? "Edit":"New"}
              </Label>
              <div
                id="CardCountUX-div-27"
                style={{display: "flex", alignItems: "center", margin: "10px 0px"}}>
                
                <label
                  id="CardCountUX-label-36"
                  style={{minWidth:"80px", maxWidth: "80px" ,fontWeight: "bold", margin: "0px 10px"}}>
                  {props.languageUX === "en" ? "Shift" : "กะ"}
                </label>
                <Input
                  fluid={true}
                  id="CardCountUX-Input-37"
                  readOnly={true}
                  style={{width:"100%"}}
                  value={props.ORCountsSequence?.selectedShift?.shift_name || ""}>
                </Input>
                <label
                  id="CardCountUX-label-38"
                  style={{fontWeight: "bold", margin: "0 1rem"}}>
                  {props.languageUX === "en" ? "Time" : "เวลา"}
                </label>
                <TimeFreeTextBox24
                  autoFocus={false}
                  className="time-custom-react-picker"
                  id="CardCountUX-TimeFreeTextBox24-62"
                  onChange={props.onChangeTime}
                  value={props.ORCountsSequence?.selectedShift?.start_time || ""}>
                </TimeFreeTextBox24>
                <label
                  id="CardCountUX-label-40"
                  style={{minWidth:"max-content",fontWeight: "bold", margin: "0 1rem 0 1.5rem"}}>
                  {props.languageUX === "en" ? "Instrument" : "อุปกรณ์"}
                </label>
                <Dropdown
                  fluid={true}
                  id="CardCountUX-Dropdown-60"
                  name="selectedShift.instrument_status_cal"
                  onChange={props.handleChangeData}
                  options={props.ORCountsSequence?.instrumentOptions || []}
                  selection={true}
                  style={{marginRight: "1rem"}}
                  value={props.ORCountsSequence?.selectedShift?.instrument_status_cal || ""}>
                </Dropdown>
              </div>
              <div
                id="CardCountUX-div-42"
                style={{display: "flex", margin: "10px 0px"}}>
                
                <label
                  id="CardCountUX-label-43"
                  style={{minWidth:"80px", maxWidth: "80px" ,fontWeight: "bold",  margin: "0.65rem 10px 0"}}>
                  {props.languageUX === "en" ? "Scrub nurse" : "พยาบาลขัดผิว"}
                </label>
                <div
                  id="CardCountUX-div-63"
                  style={{width:"100%"}}>
                  {props.scrubNurse}
                </div>
                <label
                  id="CardCountUX-label-45"
                  style={ { minWidth: "max-content", fontWeight: "bold", margin: "0.65rem 1rem 0 0"}}>
                  {props.languageUX === "en" ? "Circulating Nurse" : "พยาบาลหมุนเวียน"}
                </label>
                <div
                  id="CardCountUX-div-64"
                  style={{width: "100%"}}>
                  {props.circulatingNurse}
                </div>
              </div>
              <div
                id="CardCountUX-div-32"
                style={{display: "flex", alignItems: "center", margin: "10px 0px"}}>
                
                <div
                  id="CardCountUX-div-33"
                  style={{display:"flex", width:"auto", marginLeft: "auto"}}>
                  
                  <Button
                    color="red"
                    id="CardCountUX-Button-34"
                    onClick={props.clearSelectedShift}
                    size="small">
                    {props.languageUX === "en" ? "Clear" : "ล้างหน้าจอ"}
                  </Button>
                  <div
                    id="CardCountUX-div-67">
                    {props.createOreditShift}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            id="CardCountUX-div-65"
            style={{width: "100%"}}>
            {props.ErrorMessage}
          </div>
          <div
            id="CardCountUX-div-47">
            
            <div
              id="CardCountUX-div-48"
              style={{display: "flex", alignItems: "center", margin: "10px 0px"}}>
              
              <label
                id="CardCountUX-label-49"
                style={{width:"200px",fontWeight: "bold", fontSize: "14px", margin: "0px 10px"}}>
                {props.languageUX === "en" ? "Solve Method if count incorrect" : "วิธีแก้ไขหากนับไม่ถูกต้อง"}
              </label>
              <Dropdown
                id="CardCountUX-Dropdown-58"
                multiple={true}
                name="resolveFrom.solve_method"
                onChange={props.handleChangeData}
                options={props.ORCountsSequence?.methodOptions || []}
                selection={true}
                style={{width:"70%"}}
                value={props.ORCountsSequence?.resolveFrom?.solve_method || []}>
              </Dropdown>
            </div>
            <div
              id="CardCountUX-div-51"
              style={{display: "flex", alignItems: "center", margin: "10px 0px"}}>
              
              <label
                id="CardCountUX-label-52"
                style={{width:"200px",fontWeight: "bold", fontSize: "14px", margin: "0px 10px"}}>
                {props.languageUX === "en" ? "Remark" : "หมายเหตุ"}
              </label>
              <Input
                id="CardCountUX-Input-53"
                name="resolveFrom.remark"
                onChange={props.handleChangeData}
                style={{width:"70%"}}
                value={props.ORCountsSequence?.resolveFrom?.remark || ""}>
              </Input>
            </div>
            <div
              id="CardCountUX-div-54"
              style={{display: "flex", alignItems: "center", margin: "10px 1rem 10px", paddingBottom: "2rem"}}>
              
              <div
                id="CardCountUX-div-55"
                style={{display:"flex", width:"auto", marginLeft: "auto"}}>
                
                <div
                  id="CardCountUX-div-66">
                  {props.saveRemark}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
}


export default CardCountUX

export const screenPropsDefault = {}

/* Date Time : Wed Oct 01 2025 12:49:04 GMT+0700 (Indochina Time)
/* Original screen Data ************************************************************

{
  "elements": [
    {
      "id": 0,
      "name": "div",
      "parent": -1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardCounts"
        },
        "style": {
          "type": "code",
          "value": "{margin: \"10px\", backgroundColor: \"rgba(198, 235, 243, 0.2)\", height:\"90%\"}"
        }
      },
      "seq": 0
    },
    {
      "from": null,
      "id": 1,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardCountUX-div-1"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", alignItems: \"center\", padding: \"15px 10px 0px\"}"
        }
      },
      "seq": 1,
      "void": false
    },
    {
      "from": null,
      "id": 3,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardCountUX-div-3"
        },
        "style": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 3,
      "void": false
    },
    {
      "from": null,
      "id": 4,
      "name": "hr",
      "parent": 3,
      "props": {
        "id": {
          "type": "value",
          "value": "CardCountUX-hr-4"
        }
      },
      "seq": 4,
      "void": true
    },
    {
      "from": null,
      "id": 6,
      "name": "label",
      "parent": 1,
      "props": {
        "children": {
          "type": "value",
          "value": "นับ",
          "valueEN": "Counts"
        },
        "className": {
          "type": "value",
          "value": "header"
        },
        "id": {
          "type": "value",
          "value": "CardCountUX-label-6"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"bold\", fontSize: \"18px\", marginLeft: \"4px\"}"
        }
      },
      "seq": 6,
      "void": false
    },
    {
      "from": null,
      "id": 7,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardCountUX-div-7"
        },
        "style": {
          "type": "code",
          "value": "{height:\"90%\",margin: \"14px 14px\",backgroundColor: \"#FFFFFF\"}"
        }
      },
      "seq": 7,
      "void": false
    },
    {
      "from": null,
      "id": 23,
      "name": "div",
      "parent": 7,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardCountUX-div-23"
        },
        "style": {
          "type": "code",
          "value": "{height:\"auto\",margin: \"20px 25px\"}"
        }
      },
      "seq": 47,
      "void": false
    },
    {
      "from": "react-lib/frameworks/Table",
      "id": 24,
      "name": "Table",
      "parent": 23,
      "props": {
        "className": {
          "type": "value",
          "value": "--rt-tbody-overflow-y-hidden"
        },
        "data": {
          "type": "code",
          "value": "props.items"
        },
        "getTrProps": {
          "type": "code",
          "value": "props.shiftTableRowProps"
        },
        "headers": {
          "type": "value",
          "value": ",Time,Swab,Sharp,Instrument,Scrub Nurses,Circulating Nurses"
        },
        "id": {
          "type": "value",
          "value": "CardCountUX-Table-24"
        },
        "keys": {
          "type": "value",
          "value": "shift_name,start_time,swabStatus,sharpStatus,instrumentStatus,scrub_nurses_name,circulating_nurses_name"
        },
        "showPagination": {
          "type": "code",
          "value": "false"
        },
        "style": {
          "type": "code",
          "value": "{height: \"20vh\"}"
        },
        "widths": {
          "type": "value",
          "value": "auto,110,150,150,150,300,300"
        }
      },
      "seq": 24,
      "void": false
    },
    {
      "from": null,
      "id": 25,
      "name": "div",
      "parent": 23,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardCountUX-div-25"
        },
        "style": {
          "type": "code",
          "value": "{border:\"1px solid #ccc\", borderRadius: \"4px\", padding: \"0px 8px 4px 10px\", margin:\"10px 0px\"}"
        }
      },
      "seq": 42,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 26,
      "name": "Label",
      "parent": 25,
      "props": {
        "children": {
          "type": "code",
          "value": "props.ORCountsSequence?.selectedShift?.id ? \"Edit\":\"New\""
        },
        "color": {
          "type": "code",
          "value": "props.ORCountsSequence?.selectedShift?.id ? \"yellow\":\"blue\""
        },
        "id": {
          "type": "value",
          "value": "CardCountUX-Label-26"
        },
        "ribbon": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{margin:\"10px 3px\"}"
        }
      },
      "seq": 25,
      "void": false
    },
    {
      "from": null,
      "id": 27,
      "name": "div",
      "parent": 25,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardCountUX-div-27"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", alignItems: \"center\", margin: \"10px 0px\"}"
        }
      },
      "seq": 26,
      "void": false
    },
    {
      "from": null,
      "id": 32,
      "name": "div",
      "parent": 25,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardCountUX-div-32"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", alignItems: \"center\", margin: \"10px 0px\"}"
        }
      },
      "seq": 32,
      "void": false
    },
    {
      "from": null,
      "id": 33,
      "name": "div",
      "parent": 32,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardCountUX-div-33"
        },
        "style": {
          "type": "code",
          "value": "{display:\"flex\", width:\"auto\", marginLeft: \"auto\"}"
        }
      },
      "seq": 33,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 34,
      "name": "Button",
      "parent": 33,
      "props": {
        "children": {
          "type": "value",
          "value": "ล้างหน้าจอ",
          "valueEN": "Clear"
        },
        "color": {
          "type": "value",
          "value": "red"
        },
        "id": {
          "type": "value",
          "value": "CardCountUX-Button-34"
        },
        "onClick": {
          "type": "code",
          "value": "props.clearSelectedShift"
        },
        "size": {
          "type": "value",
          "value": "small"
        }
      },
      "seq": 34,
      "void": false
    },
    {
      "from": null,
      "id": 36,
      "name": "label",
      "parent": 27,
      "props": {
        "children": {
          "type": "value",
          "value": "กะ",
          "valueEN": "Shift"
        },
        "id": {
          "type": "value",
          "value": "CardCountUX-label-36"
        },
        "style": {
          "type": "code",
          "value": "{minWidth:\"80px\", maxWidth: \"80px\" ,fontWeight: \"bold\", margin: \"0px 10px\"}"
        }
      },
      "seq": 36,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 37,
      "name": "Input",
      "parent": 27,
      "props": {
        "disabled": {
          "type": "value",
          "value": ""
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardCountUX-Input-37"
        },
        "readOnly": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{width:\"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.ORCountsSequence?.selectedShift?.shift_name || \"\""
        }
      },
      "seq": 37,
      "void": false
    },
    {
      "from": null,
      "id": 38,
      "name": "label",
      "parent": 27,
      "props": {
        "children": {
          "type": "value",
          "value": "เวลา",
          "valueEN": "Time"
        },
        "id": {
          "type": "value",
          "value": "CardCountUX-label-38"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"bold\", margin: \"0 1rem\"}"
        }
      },
      "seq": 38,
      "void": false
    },
    {
      "from": null,
      "id": 40,
      "name": "label",
      "parent": 27,
      "props": {
        "children": {
          "type": "value",
          "value": "อุปกรณ์",
          "valueEN": "Instrument"
        },
        "id": {
          "type": "value",
          "value": "CardCountUX-label-40"
        },
        "style": {
          "type": "code",
          "value": "{minWidth:\"max-content\",fontWeight: \"bold\", margin: \"0 1rem 0 1.5rem\"}"
        }
      },
      "seq": 61,
      "void": false
    },
    {
      "from": null,
      "id": 42,
      "name": "div",
      "parent": 25,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardCountUX-div-42"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", margin: \"10px 0px\"}"
        }
      },
      "seq": 27,
      "void": false
    },
    {
      "from": null,
      "id": 43,
      "name": "label",
      "parent": 42,
      "props": {
        "children": {
          "type": "value",
          "value": "พยาบาลขัดผิว",
          "valueEN": "Scrub nurse"
        },
        "id": {
          "type": "value",
          "value": "CardCountUX-label-43"
        },
        "style": {
          "type": "code",
          "value": "{minWidth:\"80px\", maxWidth: \"80px\" ,fontWeight: \"bold\",  margin: \"0.65rem 10px 0\"}"
        }
      },
      "seq": 43,
      "void": false
    },
    {
      "from": null,
      "id": 45,
      "name": "label",
      "parent": 42,
      "props": {
        "children": {
          "type": "value",
          "value": "พยาบาลหมุนเวียน",
          "valueEN": "Circulating Nurse"
        },
        "id": {
          "type": "value",
          "value": "CardCountUX-label-45"
        },
        "style": {
          "type": "code",
          "value": " { minWidth: \"max-content\", fontWeight: \"bold\", margin: \"0.65rem 1rem 0 0\"}"
        }
      },
      "seq": 63,
      "void": false
    },
    {
      "from": null,
      "id": 47,
      "name": "div",
      "parent": 7,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardCountUX-div-47"
        }
      },
      "seq": 65,
      "void": false
    },
    {
      "from": null,
      "id": 48,
      "name": "div",
      "parent": 47,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardCountUX-div-48"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", alignItems: \"center\", margin: \"10px 0px\"}"
        }
      },
      "seq": 48,
      "void": false
    },
    {
      "from": null,
      "id": 49,
      "name": "label",
      "parent": 48,
      "props": {
        "children": {
          "type": "value",
          "value": "วิธีแก้ไขหากนับไม่ถูกต้อง",
          "valueEN": "Solve Method if count incorrect"
        },
        "id": {
          "type": "value",
          "value": "CardCountUX-label-49"
        },
        "style": {
          "type": "code",
          "value": "{width:\"200px\",fontWeight: \"bold\", fontSize: \"14px\", margin: \"0px 10px\"}"
        }
      },
      "seq": 49,
      "void": false
    },
    {
      "from": null,
      "id": 51,
      "name": "div",
      "parent": 47,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardCountUX-div-51"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", alignItems: \"center\", margin: \"10px 0px\"}"
        }
      },
      "seq": 51,
      "void": false
    },
    {
      "from": null,
      "id": 52,
      "name": "label",
      "parent": 51,
      "props": {
        "children": {
          "type": "value",
          "value": "หมายเหตุ",
          "valueEN": "Remark"
        },
        "id": {
          "type": "value",
          "value": "CardCountUX-label-52"
        },
        "style": {
          "type": "code",
          "value": "{width:\"200px\",fontWeight: \"bold\", fontSize: \"14px\", margin: \"0px 10px\"}"
        }
      },
      "seq": 52,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 53,
      "name": "Input",
      "parent": 51,
      "props": {
        "id": {
          "type": "value",
          "value": "CardCountUX-Input-53"
        },
        "name": {
          "type": "value",
          "value": "resolveFrom.remark"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeData"
        },
        "style": {
          "type": "code",
          "value": "{width:\"70%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.ORCountsSequence?.resolveFrom?.remark || \"\""
        }
      },
      "seq": 53,
      "void": false
    },
    {
      "from": null,
      "id": 54,
      "name": "div",
      "parent": 47,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardCountUX-div-54"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", alignItems: \"center\", margin: \"10px 1rem 10px\", paddingBottom: \"2rem\"}"
        }
      },
      "seq": 54,
      "void": false
    },
    {
      "from": null,
      "id": 55,
      "name": "div",
      "parent": 54,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardCountUX-div-55"
        },
        "style": {
          "type": "code",
          "value": "{display:\"flex\", width:\"auto\", marginLeft: \"auto\"}"
        }
      },
      "seq": 55,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 58,
      "name": "Dropdown",
      "parent": 48,
      "props": {
        "id": {
          "type": "value",
          "value": "CardCountUX-Dropdown-58"
        },
        "multiple": {
          "type": "code",
          "value": "true"
        },
        "name": {
          "type": "value",
          "value": "resolveFrom.solve_method"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeData"
        },
        "options": {
          "type": "code",
          "value": "props.ORCountsSequence?.methodOptions || []"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{width:\"70%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.ORCountsSequence?.resolveFrom?.solve_method || []"
        }
      },
      "seq": 58,
      "void": false
    },
    {
      "from": null,
      "id": 59,
      "name": "div",
      "parent": 7,
      "props": {
        "children": {
          "type": "code",
          "value": "props.CountTables"
        },
        "id": {
          "type": "value",
          "value": "CardCountUX-div-59"
        },
        "style": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 23,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 60,
      "name": "Dropdown",
      "parent": 27,
      "props": {
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardCountUX-Dropdown-60"
        },
        "name": {
          "type": "value",
          "value": "selectedShift.instrument_status_cal"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeData"
        },
        "options": {
          "type": "code",
          "value": "props.ORCountsSequence?.instrumentOptions || []"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{marginRight: \"1rem\"}"
        },
        "value": {
          "type": "code",
          "value": "props.ORCountsSequence?.selectedShift?.instrument_status_cal || \"\""
        }
      },
      "seq": 62,
      "void": false
    },
    {
      "from": "react-lib/apps/common",
      "id": 62,
      "name": "TimeFreeTextBox24",
      "parent": 27,
      "props": {
        "autoFocus": {
          "type": "code",
          "value": "false"
        },
        "className": {
          "type": "value",
          "value": "time-custom-react-picker"
        },
        "id": {
          "type": "value",
          "value": "CardCountUX-TimeFreeTextBox24-62"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeTime"
        },
        "value": {
          "type": "code",
          "value": "props.ORCountsSequence?.selectedShift?.start_time || \"\""
        }
      },
      "seq": 60,
      "void": false
    },
    {
      "from": null,
      "id": 63,
      "name": "div",
      "parent": 42,
      "props": {
        "children": {
          "type": "code",
          "value": "props.scrubNurse"
        },
        "id": {
          "type": "value",
          "value": "CardCountUX-div-63"
        },
        "style": {
          "type": "code",
          "value": "{width:\"100%\"}"
        }
      },
      "seq": 46,
      "void": false
    },
    {
      "from": null,
      "id": 64,
      "name": "div",
      "parent": 42,
      "props": {
        "children": {
          "type": "code",
          "value": "props.circulatingNurse"
        },
        "id": {
          "type": "value",
          "value": "CardCountUX-div-64"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        }
      },
      "seq": 64,
      "void": false
    },
    {
      "from": null,
      "id": 65,
      "name": "div",
      "parent": 7,
      "props": {
        "children": {
          "type": "code",
          "value": "props.ErrorMessage"
        },
        "id": {
          "type": "value",
          "value": "CardCountUX-div-65"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        }
      },
      "seq": 59,
      "void": false
    },
    {
      "from": null,
      "id": 66,
      "name": "div",
      "parent": 55,
      "props": {
        "children": {
          "type": "code",
          "value": "props.saveRemark"
        },
        "id": {
          "type": "value",
          "value": "CardCountUX-div-66"
        }
      },
      "seq": 66,
      "void": false
    },
    {
      "from": null,
      "id": 67,
      "name": "div",
      "parent": 33,
      "props": {
        "children": {
          "type": "code",
          "value": "props.createOreditShift"
        },
        "id": {
          "type": "value",
          "value": "CardCountUX-div-67"
        }
      },
      "seq": 67,
      "void": false
    },
    {
      "from": null,
      "id": 68,
      "name": "div",
      "parent": 1,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardCountUX-div-68"
        },
        "style": {
          "type": "code",
          "value": "{ margin: \"0px 20px\", display: \"flex\" }"
        }
      },
      "seq": 68,
      "void": false
    },
    {
      "from": null,
      "id": 72,
      "name": "div",
      "parent": 68,
      "props": {
        "children": {
          "type": "code",
          "value": "props.buttonPrint"
        },
        "id": {
          "type": "value",
          "value": "CardCountUX-div-72"
        },
        "style": {
          "type": "code",
          "value": "{ marginRight: \"10px\" }"
        }
      },
      "seq": 72,
      "void": false
    },
    {
      "from": null,
      "id": 73,
      "name": "div",
      "parent": 68,
      "props": {
        "children": {
          "type": "code",
          "value": "props.buttonUploadDocument"
        },
        "id": {
          "type": "value",
          "value": "CardCountUX-div-73"
        },
        "style": {
          "type": "code",
          "value": "{ marginRight: \"10px\" }"
        }
      },
      "seq": 73,
      "void": false
    },
    {
      "from": null,
      "id": 74,
      "name": "div",
      "parent": 68,
      "props": {
        "children": {
          "type": "code",
          "value": "props.buttonViewDocument"
        },
        "id": {
          "type": "value",
          "value": "CardCountUX-div-74"
        },
        "style": {
          "type": "code",
          "value": "{ marginRight: \"10px\" }"
        }
      },
      "seq": 74,
      "void": false
    }
  ],
  "forwardRef": false,
  "height": 85,
  "isMounted": false,
  "memo": false,
  "name": "CardCountUX",
  "project": "IsHealth",
  "screenPropsDefault": {
  },
  "width": 80
}

*********************************************************************************** */
